export default {
    SET_NAME: (state, name) => {
        state.info.name = name;
    },
    SET_AVA: (state, avatar) => {
        state.info.avatar = avatar;
    },
    SET_COM: (state, companyname) => {
        state.info.companyname = companyname;
    },
    SET_VIPTYPE:(state,vip_type)=>{
        state.info.vip_type = vip_type;
    },
    SET_VIP_LOG:(state,vip_log)=>{
        state.info.vip_log = vip_log;
    },
}